import { render, staticRenderFns } from "./MyHospital.vue?vue&type=template&id=41cf0fd9&"
import script from "./MyHospital.vue?vue&type=script&lang=js&"
export * from "./MyHospital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports